module.exports = __webpack_public_path__ + "img/uyuni2.ccad1c15.jpg";